<template>
  <tr class="is-package-header">
    <td class="align-middle p-2">
      <d-badge
        theme="dark"
        :outline="true"
        class="mr-2">
        {{ $t('service.isPackage') }}
      </d-badge>
      HELLO!
    </td>

    <td class="align-middle pt-2">
      <!--<validation-provider
        v-if="!readOnly && !serviceData.service_package_id"
        rules="required|min_value:1"
        :name="'service-package-amount-' + serviceIndex"
        v-slot="{ errors }">
        <d-input-group>
          <d-input
            :min="1"
            :state="errors.length ? 'invalid' : null"
            v-model="serviceData.count"
            @input="servicePricesUpdateDueQtyChange(serviceData.id)"
            type="number" />
          <d-input-group-text slot="append">{{ $t('ui.piecesAbbr') }}</d-input-group-text>
        </d-input-group>
      </validation-provider>
      <template v-else>
        {{ serviceData.count }} {{ $t('ui.piecesAbbr') }}
      </template>

      <small
        v-if="!userIsCustomer && parseInt(serviceData.count, 10) != $parent.$parent.$parent.productsData[$parent.$parent.productIndex].count"
        class="text-danger cursor-pointer"
        @click="setServiceAmountToProductAmount()">
        {{ $t('ui.productsGenitive') }}: {{ $parent.$parent.$parent.productsData[$parent.$parent.productIndex].count }} {{ $t('ui.piecesAbbr') }}
      </small>-->
    </td>

    <td
      :hidden="isIndent && isOffer"
      class="align-middle pt-2">
    </td>

    <td
      :hidden="isIndent && isOffer"
      class="align-middle pt-2">
    </td>

    <td
      :hidden="isIndent && isOffer"
      class="align-middle pt-2">
    </td>

    <td
      v-if="!readOnly"
      class="align-middle pt-2">
      <d-button
        size="sm"
        outline
        @click.prevent="removeServicePackage"
        theme="danger">
        {{ $t('ui.delete') }}
      </d-button>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'order-creator-service-package',
  props: [
    'isIndent',
    'isOffer',
    'readOnly',
    'productIndex',
    'servicePackageID',
    'servicePackages'
  ],
  computed: {
    servicePackageData () {
      let packageData = this.servicePackages.filter(pkg => pkg.id === this.servicePackageID);

      if (packageData && packageData[0]) {
        return packageData[0];
      }

      return {};
    }
  },
  data () {
    return {

    };
  },
  mounted () {

  },
  methods: {
    removeServicePackage () {
      if (this.servicePackageData.id) {
        this.$bus.$emit('order-remove-service-package-from-product', {
          productIndex: this.productIndex,
          packageID: this.servicePackageData.id
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.is-package-header > td {
  background: rgba(255, 180, 0, 0.25);
  border-top: 2px solid rgba(255, 180, 0, 1);
}

.is-package-header > td:first-child {
  border-left: 2px solid rgba(255, 180, 0, 1);
}

.is-package-header > td:last-child {
  border-right: 2px solid rgba(255, 180, 0, 1);
}
</style>
